import { useQuery } from "@tanstack/react-query";
import { columns } from "./partial/Columns";
import { DataTable } from "./partial/DataTable";
import api from "@/lib/axios";
import { useSearchParams } from "react-router-dom";
import { getListJalurJenis } from "@/services/getData";
import { JalurJenis } from "@/types";
import { useTahun } from "@/hooks/useTahun";

const getListDataPendaftaran = async (
  page: string,
  rowsPerPage: string,
  searchQuery: string,
  idsRefJalurJenis: string,
  idsUkParams?: string,
  statusValidasi?: string,
  statusKelulusan?: string,
  statusDaftarkembali?: string,
  statusValidasiPenunjangUkt?: string,
  statusBayarPendaftaranParams?: string,
  tahunParams?: string,
) => {
  const response = await api.get(
    `/data-pendaftaran/index?page=${page}${
      rowsPerPage ? `&rowsPerPage=${rowsPerPage}` : ""
    }${searchQuery ? `&searchQuery=${searchQuery}` : ""}${
      idsRefJalurJenis ? `&ids_ref_jalur_jenis=${idsRefJalurJenis}` : ""
    }${idsUkParams ? `&ids_uk=${idsUkParams}` : ""} ${
      statusValidasi ? `&status_validasi=${statusValidasi}` : ""
    } ${statusKelulusan ? `&status_kelulusan=${statusKelulusan}` : ""}${
      statusDaftarkembali ? `&status_daftarkembali=${statusDaftarkembali}` : ""
    } ${
      statusValidasiPenunjangUkt
        ? `&status_validasi_penunjang_ukt=${statusValidasiPenunjangUkt}`
        : ""
    }${
      statusBayarPendaftaranParams
        ? `&status_bayar_pendaftaran=${statusBayarPendaftaranParams}`
        : ""
    }${tahunParams ? `&tahun=${tahunParams}` : ""}`,
    {
      withCredentials: true,
    },
  );
  return response.data?.data;
};

export default function DataPendaftaranPage() {
  const [searchParams] = useSearchParams();
  const pageParams = searchParams.get("page");
  const rowsPerPageParams = searchParams.get("rowsPerPage");
  const searchQueryParams = searchParams.get("search");
  const idsRefJalurJenisParams = searchParams.get("ids_ref_jalur_jenis");
  const idsUkParams = searchParams.get("ids_uk");
  const statusValidasiParams = searchParams.get("status_validasi");
  const statusBayarPendaftaranParams = searchParams.get(
    "status_bayar_pendaftaran",
  );
  const statusValidasiPenunjangUktParams = searchParams.get(
    "status_validasi_penunjang_ukt",
  );
  const statusKelulusanParams = searchParams.get("status_kelulusan");
  const statusDaftarkembaliParams = searchParams.get("status_daftarkembali");

  const { selectedTahun } = useTahun();

  const { data, isPending } = useQuery({
    queryKey: [
      "listDataPendaftaran",
      pageParams,
      rowsPerPageParams,
      searchQueryParams,
      idsRefJalurJenisParams,
      idsUkParams,
      statusValidasiParams,
      statusKelulusanParams,
      statusDaftarkembaliParams,
      statusValidasiPenunjangUktParams,
      statusBayarPendaftaranParams,
      selectedTahun?.label,
    ],
    queryFn: () =>
      getListDataPendaftaran(
        pageParams as string,
        rowsPerPageParams as string,
        searchQueryParams as string,
        idsRefJalurJenisParams as string,
        idsUkParams as string,
        statusValidasiParams as string,
        statusKelulusanParams as string,
        statusDaftarkembaliParams as string,
        statusValidasiPenunjangUktParams as string,
        statusBayarPendaftaranParams as string,
        selectedTahun?.label,
      ),
  });

  const { data: listJalurJenis } = useQuery({
    queryKey: ["listJalurJenis"],
    queryFn: getListJalurJenis,
  });
  const jalurProfesi: JalurJenis = listJalurJenis?.find(
    (jalurJenis: JalurJenis) => {
      return jalurJenis.nama_jalur_jenis_slug === "profesi";
    },
  );
  const jalurRpl: JalurJenis = listJalurJenis?.find(
    (jalurJenis: JalurJenis) => {
      return jalurJenis.nama_jalur_jenis_slug === "rpl";
    },
  );

  const { data: listDataPendaftaranProfesi } = useQuery({
    queryKey: [
      "listDataPendaftaranProfesi",
      pageParams,
      rowsPerPageParams,
      searchQueryParams,
      jalurProfesi?.id_ref_jalur_jenis,
      selectedTahun?.value,
    ],
    queryFn: () =>
      getListDataPendaftaran(
        pageParams as string,
        rowsPerPageParams as string,
        searchQueryParams as string,
        jalurProfesi?.id_ref_jalur_jenis as string,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        String(selectedTahun?.value),
      ),
  });

  const { data: listDataPendaftaranRpl } = useQuery({
    queryKey: [
      "listDataPendaftaranRpl",
      pageParams,
      rowsPerPageParams,
      searchQueryParams,
      jalurRpl?.id_ref_jalur_jenis,
    ],
    queryFn: () =>
      getListDataPendaftaran(
        pageParams as string,
        rowsPerPageParams as string,
        searchQueryParams as string,
        jalurRpl?.id_ref_jalur_jenis as string,
      ),
  });

  return (
    <div>
      <DataTable
        data={data?.data || []}
        paginationData={data}
        paginationDataPendaftaranProfesi={listDataPendaftaranProfesi}
        paginationDataPendaftaranRpl={listDataPendaftaranRpl}
        columns={columns}
        isPending={isPending}
      />
    </div>
  );
}
``;
